import React from 'react';
import classnames from 'classnames';
import ListItem from './item';
import styles from './list.module.scss';
import Element from '../../element';

interface IProps  {
    className?: string;
    children: React.ReactNode;
    hoverable?: boolean;
    domRef?: any;
}

function List(props: IProps) {
    const { className, children, hoverable, ...rest } = props;
    return (
        <Element
            {...rest}
            className={classnames(styles['list'], className, {
                [styles['is-hoverable']]: hoverable,
            })}
        >
            {children}
        </Element>
    );
}

List.Item = ListItem;

export default List;
